<scitis-breadcrumb [breadcrumbRoutes]="routes"></scitis-breadcrumb>
<scitis-app-global-page-header>
  <div header-title>
    <scitis-page-header-logo-and-name
        [machineCategory]="pageGlobalParameters.machineCategory"
        [pageName]="pageGlobalParameters.pageName"
        [machineId]="pageGlobalParameters.machineId"
        [machineMenuItem]="pageGlobalParameters.associatedMenuItem.menuItemParent"
        [pageType]="pageGlobalParameters.pageType">

    </scitis-page-header-logo-and-name>
  </div>
  <ng-template #filterElement>
    <scitis-bucket-browser-page-actions class="page-functions"
                                        [bucketBrowserPageDetails]="bucketBrowserPageDetails"
                                        [searchItems]="searchItems"
                                        [hideCloseSearchButtonTimestamp]="hideCloseSearchButtonTimestamp"
                                        (layoutUpdated)="setLayout($event)"
                                        (selectedItem)="onSelectedItem($event)"
                                        (searchResultItemsUpdated)="onSearchResultItems($event)"
                                        (closeSearchTimestamp)="onCloseSearch()">
    </scitis-bucket-browser-page-actions>
  </ng-template>

</scitis-app-global-page-header>

<div class="page-content">
  <scitis-bucket-browser
      [machineId]="pageGlobalParameters.machineId"
      [organizationId]="pageGlobalParameters.organizationId"
      [pageId]="pageGlobalParameters.pageId"
      [layout]="layout"
      [selectedItem]="selectedItem"
      [searchResultItems]="searchResultItems"
      [closeSearchTimestamp]="closeSearchTimestamp"
      (bucketBrowserPageDetailsUpdated)="setBucketBrowserPageDetails($event)"
      (searchItemsUpdated)="setSearchItems($event)"
      (hideCloseSearchButtonTimestamp)="onHideCloseSearchButton()">
  </scitis-bucket-browser>
</div>
